import React, { type FunctionComponent } from 'react'
import { type Partner } from '../../../__codegen__/api'
import { useDashMessage } from '../../../intl/intl.hooks'
import { MenuOption } from './MenuOption'

interface Props {
  partner: Pick<Partner, 'id' | 'name'> & {
    retailers: { id: string; logo: { url: string } }[]
  }
  onPartnerRemoveFromRecents?: (id: string) => void
}

export const PartnerOption: FunctionComponent<Props> = ({
  partner,
  onPartnerRemoveFromRecents,
}) => {
  const banners = useDashMessage('selectPartner.banners')

  const logos = partner.retailers.map(e => e?.logo?.url).slice(0, 4)

  return (
    <MenuOption
      tagType={'retailerPartner'}
      label={partner.name}
      subLabel={`${partner.retailers.length} ${banners}`}
      logos={logos}
      onClose={
        onPartnerRemoveFromRecents &&
        (e => {
          onPartnerRemoveFromRecents(partner.id)
          e.stopPropagation()
        })
      }
    />
  )
}
